import { RouteType } from "./config";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import Users from "../pages/Users/Users";
import HomePage from "../pages/HomePage/HomePage";
import Subscription from "../pages/Accounts/Subscription/Subscription";
import SalesOrderList from "../pages/Accounts/SaleOrders/SalesOrderList";
import AccountsPageLayout from "../pages/Accounts/AccountsPageLayout";
import TrafficPage from "../pages/Accounts/Traffic";
import LicencePage from "../pages/Accounts/License";
import Notifications from "../pages/Notifications/Notifications";
import TasksPage from "../pages/Tasks/TasksPage";
import MobileUserList from "../pages/Mobiles/MobileUserList";
import SettingsIcon from "@mui/icons-material/Settings";
import Messages from "../pages/Tools/Messages";
import MobilePageLayout from "../pages/Mobiles/Mobiles";
import AddMobileUser from "../pages/Mobiles/AddMobileUser";
import EditMobileUser from "../pages/Mobiles/EditMobileUser";
import SalesOrderEdit from "../pages/Accounts/SaleOrders/SalesOrderEdit";
import SubscriptionEdit from "../pages/Accounts/Subscription/SubscriptionEdit";
import Mobilecertificate from "../pages/Mobiles/MobilecertificateList";
import TranslationUI from "../pages/TranslationUI/TranslationUI";
import Billing from "../pages/Accounts/Billing";
import PersonIcon from '@mui/icons-material/Person';
import AdminPageLayout from "../pages/Admin/admin";
import EditUser from "../pages/Users/EditUser";
import UsersRolesList from "../pages/UsersRoles/UsersRolesList";
import { appModelPermission, appPermisionName, appModelType, AppRoutesPath } from "../configs/appData";
import CommissionCounting from "../pages/CommissionCounting/CommissionCounting";
import CommissionCountingSingle from "../pages/CommissionCounting/CommissionCountingSingle";
import WholeSaleLayout from "../pages/WholeSale/WholeSaleDashboard";
import WholeSaleInvoiceReportPage from "../pages/WholeSale/WholeSaleInvoiceReport/WholeSaleInvoiceReportPage";
import WholesaleCommissionPage from "../pages/WholeSale/WholesaleCommission/WholesaleCommissionPage";
import WholeSaleListPage from "../pages/WholeSale/WholeSaleList/WholeSaleListPage";
import NewCustomerPage from "../pages/WholeSale/NewCustomer/NewCustomerPage";
// import AddSalesOrder from "../pages/Accounts/SaleOrders/AddSalesOrder";
import UsersPageLayout from "../pages/Users/UsersPageLayout";
import ApiUsers from "../pages/Users/ApiUsers";
import ResellerProducts from "../pages/ResellerProducts/ResellerProducts";
import ResellerProductsDetailed from "../pages/ResellerProducts/ResellerProductsDetailed";
import SimCard from "../pages/SimCard/SimCard";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <HomePage />,
    state: "home",
  },
  {
    path: AppRoutesPath.Notifications,
    element: <Notifications />,
    state: "notifications",
  },
  {
    path: AppRoutesPath.Users,
    element: <UsersPageLayout />,
    state: "users",
    routeStatus: null,
    sidebarProps: {
      displayText: "Users",
      icon: <PersonIcon />,
    },
    isShownChild: true,
    child: [
      {
        parent: "users",
        element: <Users />,
        state: "users",
        isChild: true,
        path: AppRoutesPath.SeteraUsers,
        routePerm: appModelPermission.SETERAUSER,
        sidebarProps: {
          displayText: "Setera Users"
        }
      },
      {
        parent: "users",
        element: <ApiUsers />,
        state: "apiusers",
        isChild: true,
        path: AppRoutesPath.ApiUsers,
        routePerm: appModelPermission.APIUSER,
        sidebarProps: {
          displayText: "API Users"
        }
      }
    ]
  },
  {
    path: AppRoutesPath.UserEdit,
    element: <EditUser />,
    state: "users.edit",
    routePerm: appPermisionName.CanChangeSeteraUser,
    routeStatus: null,
  },
  {
    path: AppRoutesPath.Accounting,
    element: <AccountsPageLayout />,
    state: "Accounting",
    sidebarProps: {
      displayText: "Accounting",
      icon: <AssignmentIndIcon />,
    },
    isShownChild: true,
    routeStatus: null,
    child: [
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingBilling,
        element: <Billing />,
        state: "accounting.Billing",
        routePerm: appModelPermission.ACCOUNTINGBILLING,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Billing",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingSubscription,
        element: <Subscription />,
        state: "accounting.subscription",
        routePerm: appModelPermission.ACCOUNTINGSUBSCRIPTION,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Subscription",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingSubscriptionEdit,
        routePerm: appModelPermission.ACCOUNTINGSUBSCRIPTION,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        element: <SubscriptionEdit />,
        state: "accounting.subscription.edit",
        isThisShow: false,
        sidebarProps: {
          displayText: "Subscription Edit",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingTraffic,
        element: <TrafficPage />,
        state: "accounting.traffic",
        routePerm: appModelPermission.ACCOUNTINGTRAFFIC,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Traffic",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingLicence,
        element: <LicencePage />,
        state: "accounting.licence",
        routePerm: appModelPermission.ACCOUNTINGLICENCE,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Licence",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingSalesOrder,
        element: <SalesOrderList />,
        state: "accounting.salesorder",
        routePerm: appModelPermission.ACCOUNTINGSALESORDER,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Sales Order",
        },
      },
      {
        parent: "accounting",
        isChild: true,
        path: AppRoutesPath.AccountingSalesOrderEdit,
        element: <SalesOrderEdit />,
        state: "accounting.saleorderedit",
        customtitle: "Sale order Edit",
        isThisShow: false,
        routePerm: appModelPermission.ACCOUNTINGSALESORDER,
        routePermUseFor: appModelType.READ,
        routeStatus: null,
        sidebarProps: {
          displayText: "Sale order Edit",
        },
      },
      // {
      //   parent: "accounting",
      //   isChild: true,
      //   path: AppRoutesPath.AccountingSalesOrderAdd,
      //   element: <AddSalesOrder />,
      //   state: "accounting.saleorderadd",
      //   customtitle: "Sale order Add",
      //   isThisShow: false,
      //   routePerm: appModelPermission.ACCOUNTINGSALESORDER,
      //   routePermUseFor: appModelType.READ,
      //   routeStatus: null,
      //   sidebarProps: {
      //     displayText: "Sale order Add",
      //   },
      // },
    ],
  },
  {
    path: AppRoutesPath.Admin,
    element: <AdminPageLayout />,
    state: "admin",
    sidebarProps: {
      displayText: "Admin",
      icon: <PersonIcon />,
    },
    isShownChild: true,
    routeStatus: null,
    child: [
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminMessage,
        element: <Messages />,
        routePerm: appPermisionName.CanViewMessage,
        state: "admin.messages",
        sidebarProps: {
          displayText: "Messages",
        }
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminTask,
        element: <TasksPage />,
        routePerm: appModelPermission.TASK,
        routePermUseFor: appModelType.READ,
        state: "admin.tasks",
        sidebarProps: {
          displayText: "Tasks",
        },
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminTranslation,
        element: <TranslationUI />,
        routePerm: appModelPermission.TRANSLATION,
        routePermUseFor: appModelType.READ,
        state: "admin.translation",
        sidebarProps: {
          displayText: "Translation",
        },
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminUsersRoles,
        element: <UsersRolesList />,
        state: "admin.userroles",
        routePerm: appPermisionName.CanViewUserRoles,
        sidebarProps: {
          displayText: "Users Roles",
        },
      },
      {
        parent: "admin",
        isChild: true,
        isThisShow: false,
        path: AppRoutesPath.AdminUsersRolesEdit,
        element: <UsersRolesList />,
        state: "admin.userroles.edit",
        routePerm: appPermisionName.CanViewUserRoles,
        sidebarProps: {
          displayText: "Users Roles Edit",
        },
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminCommissionCounting,
        element: <CommissionCounting/>,
        state: "admin.commissioncounting",
        routePermUseFor: appModelType.READ,
        routePerm: appPermisionName.CanViewMessage,
        sidebarProps: {
          displayText: "Commission Counting",
        },
      },
      {
        parent: "admin",
        isChild: true,
        isThisShow: false,
        path: AppRoutesPath.AdminCommissionCountingSingle,
        element: <CommissionCountingSingle/>,
        state: "admin.commissioncounting.single",
        routePerm: appPermisionName.CanViewMessage,
        sidebarProps: {
          displayText: "Commission Counting Detail",
        },
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminResellerPricelists,
        element: <ResellerProducts/>,
        state: "admin.resellerproducts",
        routePerm: appPermisionName.CanViewResellerProducts,
        sidebarProps: {
          displayText: "Reseller Pricelists",
        },
      },
      {
        parent: "admin",
        isChild: true,
        isThisShow: false,
        path: AppRoutesPath.AdminResellerPricelistsSingle,
        element: <ResellerProductsDetailed/>,
        state: "admin.resellerproducts.single",
        routePerm: appPermisionName.CanViewResellerProducts,
        sidebarProps: {
          displayText: "Reseller Pricelists",
        },
      },
      {
        parent: "admin",
        isChild: true,
        path: AppRoutesPath.AdminSimCardList,
        element: <SimCard/>,
        state: "admin.simcard",
        routePerm: appPermisionName.CanViewSim,
        sidebarProps: {
          displayText: "Sim Cards",
        },
      },
    ],
  },
  {
    path: AppRoutesPath.Mobile,
    element: <MobilePageLayout />,
    state: "mobiles",
    sidebarProps: {
      displayText: "Mobiles",
      icon: <SettingsIcon />,
    },
    isShownChild: true,
    routeStatus: null,
    child: [
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileUserList,
        element: <MobileUserList />,
        state: "mobiles.mobileuserlist",
        customtitle: "Mobile Subscription List",
        routePermUseFor: appModelType.READ,
        routePerm: appModelPermission.SUBSCRIPTION,
        routeStatus: null,
        sidebarProps: {
          displayText: "MobileSubscription",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileUserListAdd,
        element: <AddMobileUser />,
        state: "mobiles.mobileuseradd",
        customtitle: "Mobile Users Add",
        isThisShow: false,
        routePermUseFor: appModelType.CREATE,
        routePerm: appPermisionName.CanAddSubscription,
        routeStatus: null,
        sidebarProps: {
          displayText: "Users",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileUserListEdit,
        routePerm: appPermisionName.CanChangeSubscription,
        routeStatus: null,
        element: <EditMobileUser />,
        state: "mobiles.mobileuseredit",
        customtitle: "Mobile Subscription Edit",
        isThisShow: false,
        sidebarProps: {
          displayText: "Edit Subscription List",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileProvNotifications,
        element: <Notifications />,
        state: "mobiles.provnotifications",
        routePerm: appModelPermission.PROVNOTIFICATION,
        routeStatus: null,
        sidebarProps: {
          displayText: "Prov Notifications",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileProvNotificationsEdit,
        element: <Notifications />,
        state: "mobiles.provnotifications",
        isThisShow: false,
        routePerm: appPermisionName.CanViewProvNotification,
        routeStatus: null,
        sidebarProps: {
          displayText: "Prov Notifications",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileProvNotificationsSubscriptionEdit,
        element: <Notifications />,
        state: "mobiles.provnotifications",
        isThisShow: false,
        routePerm: appPermisionName.CanViewProvNotification,
        routeStatus: null,
        sidebarProps: {
          displayText: "Prov Notifications",
        },
      },
      {
        parent: "mobiles",
        isChild: true,
        path: AppRoutesPath.MobileCertificateList,
        element: <Mobilecertificate />,
        state: "mobiles.mobilecertificate",
        routePermUseFor: appModelType.READ,
        routePerm: appModelPermission.SUBSCRIPTIONCERTIFICATE,
        customtitle: "Mobile certificate",
        sidebarProps: {
          displayText: "Mobile certificate",
        },
      },
    ],
  },
  {
    path: AppRoutesPath.WholeSale,
    element: <WholeSaleLayout />,
    state: "wholesale",
    sidebarProps: {
      displayText: "Wholesale",
      icon: <PersonIcon />,
    },
    isShownChild: true,
    routeStatus: null,
    child:[
      {
        parent: "wholesale",
        isChild: true,
        path: AppRoutesPath.WholeSaleInvoiceReport,
        element: <WholeSaleInvoiceReportPage/>,
        routePerm: appModelPermission.COMMISSIONS,
        state: "admin.invoicereport",
        sidebarProps: {
          displayText: "InvoiceReport",
        }
      },
      {
        parent: "wholesale",
        isChild: true,
        path: AppRoutesPath.WholeSaleCommission,
        element: <WholesaleCommissionPage/>,
        routePerm: appModelPermission.COMMISSIONS,
        state: "admin.commissions",
        sidebarProps: {
          displayText: "Commissions",
        }
      },
      {
        parent: "wholesale",
          isChild: true,
          path: AppRoutesPath.NewCustomer,
          element: <NewCustomerPage/>,
          routePerm: appModelPermission.CUSTOMER,
          state: "wholesale.newcustomer",
          sidebarProps: {
            displayText: "Customer",
          }
      }
    ]
  },
  {
    path: AppRoutesPath.WholeSaleList,
    element: <WholeSaleListPage/>,
    routePerm: appModelPermission.COMMISSIONS,
    state: "null",
  }

];

export default appRoutes;